import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Translator from 'translator';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { FHEContainerForm, DatePickerFilter } from 'data/components';
import { Toastr } from 'data/common';
import { TableHomeJournalisation } from '../tables';
import { getJournalisation } from '../../../data/Homes/actions';
import selectors from '../selectors';

class Journalisation extends PureComponent {
    static propTypes = {
        getJournalisation: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        isActive: PropTypes.bool.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: props.isActive,
            needGetData: props.isActive,
            fetching: false,
            initialized: false,
            error: null,
            events: [],
            fromDate: moment()
                .add(-1, 'month')
                .unix(),
            toDate: moment().unix(),
            fromDateLimitMessage: '',
            toDateLimitMessage: '',
            tableKey: false
        };
        if (props.isActive) this.refreshEvents();
    }
    static getDerivedStateFromProps(props, state) {
        const { needGetData, loading, error, fetching, initialized, tableKey } = state;
        const { isActive } = props;
        if (isActive && !needGetData && !loading && !error && !fetching && !initialized) return { needGetData: true, loading: true };
        if (isActive && !tableKey) return { tableKey: true };
        return null;
    }

    componentDidUpdate() {
        const { isActive } = this.props;
        const { needGetData, fetching, error } = this.state;

        if (isActive && needGetData && !fetching && !error) {
            this.refreshEvents();
        }
    }

    refreshEvents = () => {
        const { getJournalisation, match } = this.props;
        const { fromDate, toDate, loading } = this.state;
        this.state.fetching = true;
        if (!loading)
            this.setState({
                loading: true
            });
        getJournalisation(match.params.homeId, fromDate, toDate)
            .then(events => {
                this.setState({
                    error: null,
                    loading: false,
                    fetching: false,
                    needGetData: false,
                    initialized: true,
                    events
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({ error: message, loading: false, needGetData: false, fetching: false });
            });
    };

    onFromDateChange = date => {
        const { toDate } = this.state;
        const fromDateLimit = moment(date).add(1, 'month');

        if (fromDateLimit < moment.unix(toDate)) {
            this.setState({
                fromDate: moment(date).unix(),
                toDate: moment(fromDateLimit).unix(),
                toDateLimitMessage: Translator.translate('generic.home.journalisation.table.body.toDateLimitMessage'),
                fromDateLimitMessage: ''
            });
        } else {
            this.setState({
                fromDate: moment(date).unix(),
                toDateLimitMessage: '',
                fromDateLimitMessage: ''
            });
        }
    };

    onToDateChange = date => {
        const { fromDate } = this.state;
        const toDateLimit = moment(date).add(-1, 'month');

        if (toDateLimit > moment.unix(fromDate)) {
            this.setState({
                toDate: moment(date).unix(),
                fromDate: moment(toDateLimit).unix(),
                fromDateLimitMessage: Translator.translate('generic.home.journalisation.table.body.fromDateLimitMessage'),
                toDateLimitMessage: ''
            });
        } else {
            this.setState({
                toDate: moment(date).unix(),
                toDateLimitMessage: '',
                fromDateLimitMessage: ''
            });
        }
    };

    render() {
        const { loading, fromDate, toDate, fromDateLimitMessage, toDateLimitMessage, events, tableKey } = this.state;
        return (
            <Fragment>
                <FHEContainerForm>
                    <DatePickerFilter
                        fromDate={moment.unix(fromDate).toDate()}
                        toDate={moment.unix(toDate).toDate()}
                        fromDateLimitMessage={fromDateLimitMessage}
                        toDateLimitMessage={toDateLimitMessage}
                        refreshFunc={this.refreshEvents}
                        onFromDateChange={this.onFromDateChange}
                        onToDateChange={this.onToDateChange}
                    />
                </FHEContainerForm>
                <TableHomeJournalisation loading={loading} events={events} key={tableKey} />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        profile: selectors.getProfile(state)
    };
}

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getJournalisation }, dispatch)
    )(Journalisation)
);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Home/sections/Journalisation.js